// Sidebar-driven session actions (rename / delete). They route through the live
// registry so an open session stays consistent: renaming a live session updates
// its store (header + persistence in step), otherwise it edits IndexedDB
// directly. Deletion always goes to IndexedDB (guarded against late flushes).

import { liveSessions } from './liveSessions'
import {
  deletePersistedSession,
  loadPersistedSession,
  renamePersistedSession
} from './sessionPersistence'
import { remoteDeleteSession, remotePutSession } from './sessionsRemote'

export async function renameSession(id: string, title: string): Promise<void> {
  const next = title.trim()
  if (!next) return
  // Update the live store (header reflects immediately) AND write IndexedDB now,
  // so a sidebar refresh shows the new title without waiting on the debounced
  // persistence flush. The live store's later flush carries the same title.
  liveSessions.get(id)?.setTitle(next)
  await renamePersistedSession(id, next)
  // Push the rename to the server (system of record). The live store's own flush
  // also mirrors, but a not-live session needs an explicit push.
  const rec = await loadPersistedSession(id)
  if (rec) void remotePutSession(rec)
}

export async function deleteSession(id: string): Promise<void> {
  void remoteDeleteSession(id)
  await deletePersistedSession(id)
}
